import { omit, values, flatten, filter, sortBy } from 'lodash';

import { colours } from './colours';

export const ALL_GOOD_STATUS_CODE = 5;
export const VERSION_UNKNOWN_STATUS_CODE = 4;
export const HIT_DIFFERENCES_STATUS_CODE = 2;
export const NEWER_VERSION_AVAILABLE_STATUS_CODE = 3;
export const MISSING_ARTIFACTS_STATUS_CODE = 1;
export const NO_ANALYSIS_STATUS_CODE = 0;

export const ARTIFACT_HEALTH_DIFF_PATH = '\\\\regression\\data\\art_health\\output';

export const ARTIFACT_HEALTH_STATUSES_MAP = {
  'All good': {
    name: 'All good',
    color: colours.green,
    symbol: 'ok-sign',
    codes: [ALL_GOOD_STATUS_CODE]
  },
  'Hit Differences': {
    name: 'Hit Differences',
    color: colours.yellow,
    symbol: 'exclamation-sign',
    codes: [HIT_DIFFERENCES_STATUS_CODE]
  },
  'Newer Version Available': {
    name: 'Newer Version Available',
    color: colours.blue,
    symbol: 'question-sign',
    codes: [NEWER_VERSION_AVAILABLE_STATUS_CODE, VERSION_UNKNOWN_STATUS_CODE]
  },
  'Missing Artifacts': {
    name: 'Missing Artifacts',
    color: colours.red,
    symbol: 'remove-sign',
    codes: [MISSING_ARTIFACTS_STATUS_CODE]
  },
  'Unknown': {
    name: 'Unknown',
    color: colours.grey,
    symbol: 'question-sign',
    codes: []
  }
};

export const ARTIFACT_HEALTH_STATUSES = [
  ARTIFACT_HEALTH_STATUSES_MAP['All good'],
  ARTIFACT_HEALTH_STATUSES_MAP['Hit Differences'],
  ARTIFACT_HEALTH_STATUSES_MAP['Newer Version Available'],
  ARTIFACT_HEALTH_STATUSES_MAP['Missing Artifacts'],
  ARTIFACT_HEALTH_STATUSES_MAP.Unknown
];

export const ARTIFACT_HEALTH_TIERS = ['Tier 1', 'Tier 2', 'Tier 3'];

export const ARTIFACT_HEALTH_ORDERS = {
  'App Name': 'name',
  'Tier': 'tier',
  'Status': 'status'
};

// Would like the status codes to resemble exit codes instead of this
export const getArtifactHealthStatusByCode = code => {
  const result = ARTIFACT_HEALTH_STATUSES.find(s => s.codes.includes(code));
  if (result) {
    return result;
  }

  return ARTIFACT_HEALTH_STATUSES_MAP.Unknown;
};

export const filterApplications = (applicationsMap, filters) => {
  return filter(flatten(values(omit(applicationsMap, filters))), application => {
    return !filters.includes('Tier ' + application.tier);
  });
};

export const sortApplications = (applications, orderBy) => {
  return sortBy(applications,
    [ARTIFACT_HEALTH_ORDERS[orderBy], ARTIFACT_HEALTH_ORDERS['App Name']]);
};


// WEBPACK FOOTER //
// src/helpers/artifactHealth.js